import React, { useState, useRef } from "react";

const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB

function UploadZone({ label, hint, accept, onChange, multiple }) {
  const [fileNames, setFileNames] = useState([]);
  const inputRef = useRef(null);
  return (
    <div className="upload-zone" onClick={() => inputRef.current?.click()}>
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        multiple={!!multiple}
        style={{ display:'none' }}
        onChange={e => {
          const files = multiple ? Array.from(e.target.files) : [e.target.files[0]];
          const valid = files.filter(Boolean);
          if (!valid.length) return;
          const oversized = valid.find(f => f.size > MAX_FILE_SIZE);
          if (oversized) { alert(`"${oversized.name}" is too large (${(oversized.size/1024/1024).toFixed(1)}MB). Maximum file size is 5MB.`); e.target.value=''; return; }
          setFileNames(valid.map(f => f.name));
          onChange && onChange(multiple ? valid : valid[0]);
        }}
      />
      <div className="upload-icon">{fileNames.length > 0 ? '\u2705' : '\ud83d\udcce'}</div>
      <div style={{ fontWeight:600, marginBottom:4 }}>
        {fileNames.length > 0
          ? (multiple && fileNames.length > 1 ? `${fileNames.length} files selected` : fileNames[0])
          : `Upload ${label}`}
      </div>
      <div style={{ fontSize:13, color:'#a89a8a' }}>{hint}</div>
    </div>
  );
}

export { MAX_FILE_SIZE };
export default UploadZone;
